import { Sens } from '@mairistem/comptabilite';

export interface ModeReglementType {
  key: string,
  text: string,
  value: string,
}

export const MODE_REGLEMENT = {
  DEPENSE: {
    NUMERAIRE: '01',
    CHEQUE: '02',
    VIREMENT: '03',
    VIREMENT_APP_EXTERNE: '04',
    VIREMENT_GROS_MT: '05',
    VIREMENT_ETRANGER: '06',
    OPERATION_BUD_RATT: '07',
    OPERATION_ORDRE: '08',
    AVIS_DE_REGL: '09',
    PRELEVEMENT: '10',
    VIREMENT_INTERNE: '11',
  },
  RECETTE: {
    NUMERAIRE: '01',
    CARTE_BANCAIRE: '02',
    CHEQUE: '03',
    TITRE_EMPLOI_SERVICE: '04',
    TITRE_INTERBANCAIRE_PAIEMENT: '05',
    PRELEVEMENT: '06',
    VIREMENT: '07',
    OPERATION_ORDRE: '08',
    AUTRES: '09',
  },
  DEPENSE_LIST: [
    {
      key: '01',
      text: '01 Numéraire',
      value: '01',
    },
    {
      key: '02',
      text: '02 Chèque',
      value: '02',
    },
    {
      key: '03',
      text: '03 Virement',
      value: '03',
    },
    {
      key: '04',
      text: '04 Virement appli externe',
      value: '04',
    },
    {
      key: '05',
      text: '05 Virement gros montant',
      value: '05',
    },
    {
      key: '06',
      text: "06 Virement à l'étranger",
      value: '06',
    },
    {
      key: '07',
      text: '07 Opération budget rattaché',
      value: '07',
    },
    {
      key: '08',
      text: "08 Opération d'ordre",
      value: '08',
    },
    {
      key: '09',
      text: '09 Avis de règlement-Autres',
      value: '09',
    },
    {
      key: '10',
      text: '10 Prélèvement',
      value: '10',
    },
    {
      key: '11',
      text: '11 Virement interne',
      value: '11',
    },
  ],
  RECETTE_LIST: [
    {
      key: '01',
      text: '01 Numéraire',
      value: '01',
    },
    {
      key: '02',
      text: '02 Carte bancaire',
      value: '02',
    },
    {
      key: '03',
      text: '03 Chèque',
      value: '03',
    },
    {
      key: '04',
      text: '04 Titre emploi service',
      value: '04',
    },
    {
      key: '05',
      text: '05 Titre interbancaire de paiement',
      value: '05',
    },
    {
      key: '06',
      text: '06 Prélèvement',
      value: '06',
    },
    {
      key: '07',
      text: '07 Virement',
      value: '07',
    },
    {
      key: '08',
      text: '08 Opération d\'ordre',
      value: '08',
    },
    {
      key: '09',
      text: '09 Autres',
      value: '09',
    },
  ],
} as const;

/**
 * Permet de savoir si le modeDeReglement choisi permet d'afficher la référence bancaire et les libelles de virement.
 */
export const isLibelleReferenceVisible = (
  modeReglement: string,
  sens: Sens,
): boolean => {
  const reglements: string[] = sens === Sens.DEPENSE
    ? [MODE_REGLEMENT.DEPENSE.VIREMENT, MODE_REGLEMENT.DEPENSE.VIREMENT_GROS_MT]
    : [MODE_REGLEMENT.RECETTE.VIREMENT];
  return reglements.includes(modeReglement);
};

export const getModeReglement = (sens: string) => {
  if (sens === Sens.DEPENSE) {
    return MODE_REGLEMENT.DEPENSE_LIST;
  }
  return MODE_REGLEMENT.RECETTE_LIST;
};
